import { Sidebar } from "./Sidebar";
import { ADMIN_SIDEBAR_NAV } from "./sidebar-config";

export function AdminSidebar() {
  return (
    <Sidebar
      homePath="/admin/users"
      navItems={ADMIN_SIDEBAR_NAV}
      sectionLabel="Admin"
    />
  );
}
